enum ConversionProgressEnum {
  Start = "10",
  Pending = "50",
  HalfConversion = "75",
  NearlyDone = "90",
  Success = "100",
}

export { ConversionProgressEnum };
